import { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import httpInjectorService from "services/http-injector.service";
import { settaskBoardDetails, settaskstatuscount } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { setEpiclist } from "store/actions";
 
const { Option } = Select;
 
const EpicList = ({ project_id, status, getTaskBoardDetails }) => {

  const [loading, setLoading] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState(null);
  const dispatch = useDispatch();
  const epiclist=useSelector(state=>state?.Authentication?.Epiclist)
 
  useEffect(() => {
    getEpiclist();
  }, [project_id]);
 
  const getEpiclist = async () => {
    setLoading(true);
    const queryParams = `?project_id=${project_id}`;
    try {
      const response = await httpInjectorService.get_epic(queryParams);
      dispatch(setEpiclist(response.data)) 
    } catch (error) {
    throw error
    } finally {
      setLoading(false);
    }
  };
 
  const fetchTasksByEpicId = async (epicId) => {
    if (!epicId) return;
    const queryParams = `?project_id=${project_id}&epic_id=${epicId}`;
    try {
      const response = await httpInjectorService.gettaskDetailsbyEpicId(queryParams);
 
      if (response.status === "success" && Array.isArray(response.data?.tasks)) {
        const grouped = {};
 
        // Initialize groups by statuses
        status?.forEach((s) => {
          grouped[s.status_name] = [];
        });
 
        response.data.tasks.forEach((task) => {
          const simplifiedTask = {
            id: task.task_id,
            title: task.task_title,
            assignee_id: task.assignee_id,
            assignee_name: task.assignee_name,
            project_id: task.project_id,
            epic_key: task.epic_key,
            task_status: task.task_status,
            task,
          };
 
          if (grouped[task.task_status]) {
            grouped[task.task_status].push(simplifiedTask);
          }
        });
         
        dispatch(settaskBoardDetails(grouped));
        dispatch(settaskstatuscount(response.data?.task_status_count || {}));
      } else {
       
        dispatch(settaskstatuscount({}));
        dispatch(settaskBoardDetails({}));
      }
    } catch (error) {
     throw error
    }
  };
 
  // const handleSelectEpic = (epicId) => {
  //   setSelectedEpic(epicId);
 
  //   if (epicId) {
  //     // ✅ user selected an epic
  //     fetchTasksByEpicId(epicId);
  //   } else {
  //     // ✅ user cleared the selection
  //     getTaskBoardDetails();
  //   }
  // };
 
  return (
   
      <Select
        showSearch
        allowClear
        placeholder="Select Epic"
        value={selectedEpic}
        // onChange={handleSelectEpic}
        optionFilterProp="children"
        style={{ minWidth: 220 }}
      >
        {epiclist?.map((item) => (
          <Option key={item.epic_id} value={item.epic_id}>
            {item.epic_name}
          </Option>
        ))}
      </Select>
  );
};
 
export default EpicList;